import { GetAllExpeditionBoResponseDtoExpedition } from "@/types/api/api-types";
import { CustomQuotationTypeEnum } from "@/constants/enums/customQuotationType.enum";
import { useTranslation } from "react-i18next";
import { Badge } from "../../ui/badge";

type Props = {
  expedition: Pick<GetAllExpeditionBoResponseDtoExpedition, "quotation" | "customQuotation">;
};

export const PackagingTypeBadge = ({ expedition }: Props) => {
  const { t } = useTranslation("shared");
  const quotation = expedition.quotation;
  const standard = quotation?.quotationWoodBox?.length === 0;
  const customQuotationParcel = expedition.customQuotation?.type === CustomQuotationTypeEnum.PARCEL;
  const customQuotationPalette =
    expedition.customQuotation?.type === CustomQuotationTypeEnum.PALETTE;
  const customQuotationOther = expedition.customQuotation?.type === CustomQuotationTypeEnum.OTHER;

  if (quotation) {
    if (standard) {
      return (
        <Badge variant="gray" className="border-0 px-2 uppercase">
          {t("packagingTypeBadge.standard")}
        </Badge>
      );
    } else {
      return (
        <Badge variant="brown" className="border-0 px-2 uppercase">
          {t("packagingTypeBadge.woodbox")}
        </Badge>
      );
    }
  } else if (customQuotationParcel) {
    return (
      <Badge variant="indigo" className="border-0 px-2 uppercase">
        {t("packagingTypeBadge.parcel")}
      </Badge>
    );
  } else if (customQuotationPalette) {
    return (
      <Badge variant="orange" className="border-0 px-2 uppercase">
        {t("packagingTypeBadge.palette")}
      </Badge>
    );
  } else if (customQuotationOther) {
    if (expedition.customQuotation?.otherDetail) {
      if (expedition.customQuotation?.otherDetail?.isMultipleExpedition) {
        return (
          <Badge variant="blue" className="border-0 px-2 uppercase">
            {t("packagingTypeBadge.otherMultiple")}
          </Badge>
        );
      } else {
        return (
          <Badge variant="blue" className="border-0 px-2 uppercase">
            {t("packagingTypeBadge.otherSingle")}
          </Badge>
        );
      }
    } else {
      return (
        <Badge variant="blue" className="border-0 px-2 uppercase">
          {t("packagingTypeBadge.other")}
        </Badge>
      );
    }
  }
  return <></>;
};
